<template>
  <div class="developer-incoming-files">
    <BaseCard
      :has-divider="true"
      :has-main-container="true"
      base-card-title-class="app-font-semibold title mb-1"
      data-v-step="0"
    >
      <template v-slot:header-title>
        Arquivos Recebidos
      </template>
      <v-row class="mt-4">
        <v-col sm="3">
          <v-select
            v-model="filter.initiator"
            :items="getInitiators"
            clearable
            label="Originador"
          />
        </v-col>
        <v-col sm="3">
          <BaseInput
            v-model="filter.context"
            label="Contexto"
            clearable
            class="mr-2"
          />
        </v-col>
        <v-col sm="2">
          <BaseDatePicker
            name-placeholder="Data Inicial"
            :date-value="filter.startDate"
            :max="null"
            locale="pt-br"
            time-zone="UTC"
            @on-input-date-picker="(value) => { updateDatePicker(value, 'startDate') }"
          />
        </v-col>
        <v-col sm="2">
          <BaseDatePicker
            name-placeholder="Data Final"
            :date-value="filter.endDate"
            :max="null"
            locale="pt-br"
            time-zone="UTC"
            @on-input-date-picker="(value) => { updateDatePicker(value, 'endDate') }"
          />
        </v-col>
        <v-col
          sm="2"
          class="app-align-items-center"
        >
          <BaseButton
            type="text"
            color="blueff"
            class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
            @click="filterEnvelopeList"
          >
            Filtrar
          </BaseButton>
        </v-col>
      </v-row>
      <BaseDataTable
        :headers="headers"
        :items="incomingFiles"
        :hide-actions="false"
        background-color="transparent"
        :total-items="((pagination.page + 1) * pagination.itemsPerPage) + 1"
        :has-infinite-pagination="true"
        :options="pagination"
        @update-pagination="updatePagination"
      >
        <template v-slot:inject-items="scopedItems">
          <tr
            v-for="value in scopedItems"
            :key="value.index"
          >
            <td>
              {{ value.item.createdAt | getExactDateTime }}
            </td>
            <td>
              {{ value.item.initiator }}
            </td>
            <td>
              {{ value.item.context }}
            </td>
            <td>
              {{ value.item.fileName }}
            </td>
            <td>
              {{ value.item.filePath }}
            </td>
            <td
              class="text-right"
            >
              <BaseMenuOptions
                :menu-itens="menuItens"
                :item-data="value"
                align-menu="left"
              />
            </td>
          </tr>
        </template>
        <template v-slot:custom-text-no-data>
          <div class="text-center">
            Nenhum arquivo para exibir
          </div>
        </template>
      </BaseDataTable>
      <v-dialog
        v-model="isModalActive"
        persistent
        :max-width="contextModal !== 'audit' ? '560' : '60vw'"
      >
        <BaseModal
          :show-indeterminate-progress="modalFile.showIndeterminateProgress"
          :top-slot-content-title="modalFile.topSlotContentTitle"
          :remove-button-close="modalFile.removeButtonClose"
          :middle-slot-content-text-highlight="modalFile.middleSlotContentTextHighlight"
          :middle-slot-content-text="modalFile.middleSlotContentText"
          :bottom-buttons-align="modalFile.bottomButtonsAlign"
          :bottom-slot-content-button-cancel-label="modalFile.bottomSlotContentButtonCancelLabel"
          :bottom-slot-content-button-confirm-label="modalFile.bottomSlotContentButtonConfirmLabel"
          :remove-button-cancel="modalFile.removeButtonCancel"
          :remove-button-confirm="modalFile.removeButtonConfirm"
          :custom-enable-bottom-button-confirm-label="valid"
          @on-cancel="closeModal"
          @on-confirm="() => modalFile.onConfirm()"
        >
          <template v-if="contextModal == 'reprocess' || contextModal == 'cancel'">
            <p v-if="selectedFile">
              Tem certeza que deseja {{ contextModal == 'reprocess' ? 'reprocessar' : 'cancelar' }} o arquivo <b>{{ selectedFile.fileName || 'Arquivo sem nome' }}?</b>
              <br /><br />
              Informe o motivo do {{ contextModal == 'reprocess' ? 'reprocessamento' : 'cancelamento' }}, incluindo a descrição do problema, link do chamado e outras informações relevantes.
            </p>
            <v-form
              ref="formFile"
              v-model="valid"
            >
              <v-textarea
                v-model="file.reason"
                class="mt-4"
                :counter="1000"
                label="Motivo"
                :rules="[isValid]"
                rows="4"
                auto-grow
              />
            </v-form>
          </template>
          <template v-if="contextModal == 'audit'">
            <span class="app-font-semibold">
              Arquivo: <b>{{ selectedFile.fileName }}</b>
            </span>
            <BaseDataTable
              :headers="headersAudit"
              :items="itemsListLogs"
              :hide-actions="false"
              class="pt-4"
              :options="paginationLogs"
              background-color="transparent"
            >
              <template v-slot:inject-items="scopedItems">
                <tr
                  v-for="value in scopedItems"
                  :key="value.index"
                >
                  <td style="width: 200px;">
                    {{ value.item.timestamp | getDate }} - {{ value.item.timestamp | getFullTime }}
                  </td>
                  <td>
                    {{ parseInitiatedBy(value.item) }}
                  </td>
                  <td>
                    {{ value.item.action }}
                  </td>
                  <td
                    class="d-flex justify-space-between align-center"
                    style="max-width: 350px;"
                  >
                    <span
                      class="text-truncate"
                      style="max-width: 180px;"
                    >
                      {{ reasonReprocess(value.item.data) }}
                    </span>
                    <BaseButton
                      v-if="reasonReprocess(value.item.data) && reasonReprocess(value.item.data).length > 40"
                      type="text"
                      color="primary"
                      :has-icon="true"
                      @click="openReasonModal(value.item.data)"
                    >
                      <v-icon>
                        mdi-dots-horizontal-circle-outline
                      </v-icon>
                    </BaseButton>
                  </td>
                </tr>
              </template>
            </BaseDataTable>
            <v-dialog
              v-model="reasonModalActive"
              max-width="560"
              scrollable
            >
              <BaseModal
                :show-indeterminate-progress="reasonModal.showIndeterminateProgress"
                :top-slot-content-title="reasonModal.topSlotContentTitle"
                :remove-button-close="reasonModal.removeButtonClose"
                :middle-slot-content-text-highlight="reasonModal.middleSlotContentTextHighlight"
                :middle-slot-content-text="reasonModal.middleSlotContentText"
                :bottom-buttons-align="reasonModal.bottomButtonsAlign"
                :bottom-slot-content-button-cancel-label="reasonModal.bottomSlotContentButtonCancelLabel"
                :bottom-slot-content-button-confirm-label="reasonModal.bottomSlotContentButtonConfirmLabel"
                :remove-button-cancel="reasonModal.removeButtonCancel"
                :remove-button-confirm="reasonModal.removeButtonConfirm"
                :custom-enable-bottom-button-confirm-label="reasonModal.customEnableBottomButtonConfirmLabel"
                @on-cancel="reasonModalActive = false"
              >
                <template>
                  <span class="reason-text">
                    {{ reasonReprocess(reasonFullText) }}
                  </span>
                </template>
              </BaseModal>
            </v-dialog>
          </template>
        </BaseModal>
      </v-dialog>
    </BaseCard>
    <BaseSnackbar
      :active-snackbar="feedback"
      :type-snackbar="feedbackColor"
      :text-snackbar="feedbackMessage"
      @closeSnackbar="feedback = !feedback"
    />
  </div>
</template>

<script>
import BaseDataTable from '../../BaseDataTable'
import { mapActions, mapGetters, mapState } from 'vuex'
import permissions from '../../../mixins/permissions';
import BaseDatePicker from '../../BaseDatePicker'
import BaseModal from '../../BaseModal'
import BaseSnackbar from '../../BaseSnackbar'
import BaseSnackbarConfiguration from '../../../mixins/BaseSnackbarConfiguration'
import BaseMenuOptions from '../../BaseMenuOptions'

export default {
  name: 'DeveloperIncomingFiles',
  components: { BaseDataTable, BaseDatePicker, BaseModal, BaseSnackbar, BaseMenuOptions },
  mixins: [ permissions, BaseSnackbarConfiguration ],
  data() {
    return {
      valid: false,
      isModalActive: false,
      modalFile: {
        showIndeterminateProgress: false,
        topSlotContentTitle: "",
        removeButtonClose: false,
        middleSlotContentTextHighlight: "",
        middleSlotContentText: "",
        bottomButtonsAlign: "right",
        bottomSlotContentButtonCancelLabel: "Fechar",
        bottomSlotContentButtonConfirmLabel: "Confirmar",
        removeButtonCancel: false,
        removeButtonConfirm: false,
        onCancel: null,
        onConfirm: null
      },
      reasonModalActive: false,
      reasonModal: {},
      reasonFullText: "",
      contextModal: null,
      selectedFile: null,
      file: {
        reason: ''
      },
      filter: {
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date().toISOString().substr(0, 10),
        initiator: '',
        context: '',
      },
      pagination: {
        page: 1,
        itemsPerPage: 25
      },
      paginationLogs: {
        page: 1,
        itemsPerPage: 5
      },
      headers: [
        {
          text: 'Data',
          value: 'createdAt',
          sortable: false,
          width: 150
        },
        {
          text: 'Originador',
          value: 'initiator',
          sortable: false
        },
        {
          text: 'Contexto',
          value: 'context',
          sortable: false
        },
        {
          text: 'Nome',
          value: 'fileName',
          sortable: false
        },
        {
          text: 'Path',
          value: 'filePath',
          sortable: false
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
        }
      ],
      headersAudit: [
        {
          text: 'Data',
          value: 'timeStamp',
          sortable: false,
        },
        {
          text: 'Solicitante',
          value: 'applicant',
          sortable: false,
        },
        {
          text: 'Ação',
          value: 'action',
          sortable: false,
        },
        {
          text: 'Motivo',
          value: 'reason',
          sortable: false,
        },
      ]
    }
  },
  computed: {
    ...mapGetters(['getInitiators']),
    ...mapState({
      incomingFiles: state => state.incomingFiles.incomingFiles,
      logsIncomingFiles: state => state.incomingFiles.logsIncomingFiles
    }),
    itemsListLogs() {
      return this.logsIncomingFiles.content || []
    },
    menuItens() {
      return [
        {
          text: "Baixar",
          icon: "mdi-tray-arrow-down",
          execute: (value) => {
            this.downloadFile(value.item.uuid, value.item.fileName)
          },
          disableButton(item) {
            return false
          },
          hideButton(item){
            return false
          }
        },
        {
          text: "Monitoramento",
          icon: "mdi-file-eye-outline",
          execute: (value) => {
            this.executionFile(value.item)
          },
          disableButton(item) {
            return false
          },
          hideButton(item){
            return item.item.fileInfo && item.item.fileInfo[0] && item.item.fileInfo.find((file) => file.name == 'execution') ? false : true
          }
        },
        {
          text: "Reprocessar",
          icon: "mdi-file-document-refresh-outline",
          execute: (value) => {
            this.reprocessFileModal(value.item)
          },
          disableButton(item) {
            return false
          },
          hideButton(item){
            return false
          }
        },
        {
          text: "Cancelar",
          icon: "mdi-file-document-remove-outline",
          execute: (value) => {
            this.cancelFileModal(value.item)
          },
          disableButton(item) {
            return false
          },
          hideButton(item){
            return false
          }
        },
        {
          text: "Auditoria",
          icon: "mdi-file-search-outline",
          execute: (value) => {
            this.auditFileModal(value.item)
          },
          disableButton(item) {
            return false
          },
          hideButton(item){
            return false
          }
        }
      ]
    },
  },
  async created(){
    await this.apiGetInitiators();
    await this.getIncomingFiles();
  },
  methods: {
    ...mapActions(['apiGetInitiators', 'apiGetDownloadFile', 'apiGetIncomingFiles', 'apiReprocessFile', 'apiGetLogsIncomingFiles', 'apiCancelFile']),
    updateDatePicker(value, prop) {
      this.$set(this.filter, prop, value)
    },
    downloadFile(uuid, name) {
      this.apiGetDownloadFile({
        uuid: uuid,
        fileName: name
      })
    },
    async getIncomingFiles() {
      let payload  = {
        ...this.filter,
        context: this.filter.context ? `%${this.filter.context.trim()}%` : '',
        pageSize: this.pagination.itemsPerPage,
        pageNumber: this.pagination.page - 1
      }
      await this.apiGetIncomingFiles(payload);
    },
    updatePagination(pagination) {
      const reducePaginationAttributes = {
        page: pagination.page,
        itemsPerPage: pagination.itemsPerPage,
      }
      this.pagination = reducePaginationAttributes
      this.getIncomingFiles()
    },
    filterEnvelopeList(){
      this.pagination.page = 1
      this.getIncomingFiles()
    },
    executionFile(file) {
      if(file.fileInfo && file.fileInfo[0]) {
        const executionFile = file.fileInfo.find((file) => file.name == 'execution')

        const route = this.$router.resolve({
          path: `/developer/executions/${executionFile.value}`
        })

        window.open(route.href, '_blank')
      } else {
        this.showFeedback({
          color: "error",
          message: 'Não foi possível acessar o monitoramento desse arquivo!',
        })
      }
    },
    reprocessFileModal(file){
      this.selectedFile = file
      this.contextModal = 'reprocess'

      Object.assign(this.modalFile, {
        ...this.modalFile,
        topSlotContentTitle: "Reprocessar arquivo",
        bottomSlotContentButtonCancelLabel: "Cancelar",
        bottomSlotContentButtonConfirmLabel: "Reprocessar",
        removeButtonConfirm: false,
        onConfirm: () => this.reprocessFile(file)
      })
      this.isModalActive = true
    },
    cancelFileModal(file) {
      this.selectedFile = file
      this.contextModal = 'cancel'

      Object.assign(this.modalFile, {
        ...this.modalFile,
        topSlotContentTitle: "Cancelar arquivo",
        bottomSlotContentButtonConfirmLabel: "Confirmar",
        removeButtonConfirm: false,
        onConfirm: () => this.cancelFile(file)
      })
      this.isModalActive = true
    },
    closeModal() {
      this.isModalActive = false
      this.selectedFile = null

      if(this.$refs.formFile){
        this.$refs.formFile.reset()
      }

      this.file.reason = ''
      this.contextModal = null
    },
    async reprocessFile(file) {
      const payload = {
        ...file,
        reason: this.file.reason
      }
      try {
        await this.apiReprocessFile(payload)

        this.showFeedback({
          color: "success",
          message: 'Arquivo reprocessado com sucesso!',
        })
      } catch(error) {
        this.showFeedback({
          color: "error",
          message: 'Erro ao reprocessar arquivo!',
        })
      } finally {
        this.closeModal()
      }
    },
    async cancelFile(file) {
      const payload = {
        ...file,
        reason: this.file.reason
      }
      try {
        await this.apiCancelFile(payload)

        this.showFeedback({
          color: "success",
          message: 'Arquivo cancelado com sucesso!',
        })
      } catch(error) {
        this.showFeedback({
          color: "error",
          message: 'Erro ao cancelar arquivo!',
        })
      } finally {
        this.closeModal()
      }
    },
    auditFileModal(file) {
      this.selectedFile = file
      this.contextModal = 'audit'
      this.auditFile(this.selectedFile)

      Object.assign(this.modalFile, {
        ...this.modalFile,
        topSlotContentTitle: "Auditoria",
        bottomSlotContentButtonConfirmLabel: "",
        removeButtonConfirm: true,
        onConfirm: null
      })
      this.isModalActive = true
    },

    async auditFile(file) {
      const payload = {
        entity_id: `incoming-files-${file.uuid}`,
        page_size: "50"
      }

      try {
        await this.apiGetLogsIncomingFiles(payload)
      } catch (error) {
        this.showFeedback({
          color: "error",
          message: 'Erro ao acessar os dados.',
        })
      }
    },
    reasonReprocess(value) {
      if(value && value.payload) {
        const parsedPayload = JSON.parse(value.payload)
        return (parsedPayload.url || '')
      } else {
        return ''
      }
    },
    truncate(text, length = 80) {
      if (!text) return "-"
      return text.length > length ? text.substring(0, length) + "..." : text
    },
    openReasonModal(text) {
      this.reasonFullText = text

      Object.assign(this.reasonModal, {
        showIndeterminateProgress: false,
        topSlotContentTitle: "Motivo do reprocessamento",
        removeButtonClose: false,
        middleSlotContentTextHighlight: "",
        middleSlotContentText: "",
        bottomButtonsAlign: "right",
        bottomSlotContentButtonCancelLabel: "Fechar",
        bottomSlotContentButtonConfirmLabel: "",
        removeButtonCancel: false,
        removeButtonConfirm: true,
        onCancel: null,
        onConfirm: null
      })

      this.reasonModalActive = true
    }
  }
}
</script>

<style scoped>
  .reason-text {
    white-space: pre-line;
  }
</style>
